/**
 * useAppDispatch Hook
 * Typed dispatch hook for store-front Redux actions
 */

import { useDispatch } from 'react-redux';

import type { AppDispatch } from '../store';

// Use throughout the app instead of plain `useDispatch`
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default useAppDispatch;
